<div class="main d-flex flex-column">
  <div class="d-flex flex-row-reverse"><mat-icon (click)="cancel()">close</mat-icon></div>
  <div class="content">
    <h2 mat-dialog-title>
      {{ 'app.dialog.message' | translate }}
    </h2>
  </div>
</div>